/* eslint-disable @typescript-eslint/no-unused-vars */
export const getKeywordInputStyles = (_, { palette = {} }) => ({
  keywordInputContainer: {
    width: 928,
  },
  filed: {
    marginTop: 20,
  },
  labelContainer: {
    marginBottom: 8,
  },
  helpLink: {
    marginLeft: 5,
  },
  textArea: {
    height: 220,
  },
});

export const messageBarStyle = {
  root: {
    background: '#eff6fc',
    '& span.iconba-Insights': {
      fontSize: '16px',
      top: 0,
      color: '#0078D4',
    },
  },
  innerText: {
    lineHeight: 21,
  },
};
